import Vue from 'vue';
import Router from 'vue-router';
import { routes } from './routes';
import store from '../store/index';
import { Helper } from '../lib/helper';
import Cookie from 'js-cookie';

if (process && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development')) {
  Vue.use(Router);
}
const router = new Router({
  routes,
});

function checkToRedirect({
  isBindKg,
  isBindWs,
  to,
  next,
}) {
  if (to.fullPath === '/userCenter' && !Helper.getLoginInfo()) {
    Helper.setLoginInfo();
    if (isBindKg) {
      next('/manage/kg');
      return true;
    }

    if (isBindWs) {
      next('/manage/ws');
      return true;
    }
  }

  return false;
}

router.beforeEach(async (to, from, next) => {
  let {
    profile,
  } = store.state.userCenter;
  const token = Cookie.get('eBusinessToken');

  if (to.meta.auth && to.meta.auth === 'noAuth') {
    return next();
  }

  if (!token) {
    return next('/welcome');
  }

  if (!profile.user_id) {
    try {
      const profileRes = await store.dispatch('userCenter/fetchCpProfile');
      profile = store.state.userCenter.profile || {};

      if (from.route === '/login' && profile.role === 0) {
        Vue.prototype.$tip.error('您尚未被通过邀请，请稍后再试');
        return next('/login');
      }

      if (profile.uid === 0) {
        const profileState = profile.state;
        const stateArr = [
          { state: 0, step: 1 },
          { state: 1, step: 4 },
          { state: 3, step: 4 },
        ];
        const stateStep = stateArr.find(item => item.state === profileState);
        if (stateStep) {
          return next({
            path: '/register',
            query: {
              step: stateStep.step,
            },
          });
        }
      }

      if (profileRes === false) {
        return next('/login');
      }

      const {
        isBindKg,
        isBindWs,
      } = store.getters;

      if (
        checkToRedirect({
          isBindKg,
          isBindWs,
          to,
          next,
        })
      ) {
        return true;
      }
    } catch (e) {
      console.log(e);
    }
  }

  // 非管理员无法访问结算中心
  if (to.path.indexOf('settlement') !== -1 && profile.role !== 100) {
    return next('/404');
  }
  next();
  return true;
});


export default router;
